import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });

/** Owner: GET /roles/all */
export const getAllRoles = async () => {
  const res = await axiosInstance.get("/roles/all");
  return res.data;
};
